import React from 'react';

const DashFooter = () => {
  return (
    <div className='text-center text-white mt-3 py-3'>
      <p>HopePoints</p>
    </div>
  );
};

export default DashFooter;
